
export default {
  operations: [],
  operation: [],
  operationproducts: []
}
